import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation AcceptLongFormSectionContent($ids: [ID!]!) {
    acceptLongFormSectionContent(ids: $ids) {
      id
    }
  }
`;

export const acceptLongFormSectionContent = ({ ids }) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { ids },
  }).then(({ data }) => getSingleProp(data));
};
